import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MareTranslateService {

  constructor(
    private translateService: TranslateService
  ) {
    
   }

   getTranslate(key: string | string[], methodGet: boolean) {
    if (methodGet) {
      this.translateService.get(key).subscribe((res: any) => {
        return res
      })
    } else {
      return this.translateService.instant(key)
    }
    
  }
}
